<template>
  <div class="contain">
    <div class="title">基础用法</div>
    <div class="wrapper top">
      <mx-launch-app>
        <div class="common-class">
          <span class="text-class">唤起美居APP，进入首页</span>
        </div>
      </mx-launch-app>
    </div>

    <div class="title">安卓环境，引导下载美居APP</div>
    <div class="wrapper top">
      <mx-launch-app :androidDownload="yingyongbao"
        ><div class="common-class">
          <span class="text-class">前往应用宝，下载美居APP</span>
        </div></mx-launch-app
      >
    </div>
    <div class="wrapper top">
      <mx-launch-app :androidDownload="androidAppMarket"
        ><div class="common-class">
          <span class="text-class">前往App Store，下载美居APP</span>
        </div></mx-launch-app
      >
    </div>
    <div class="wrapper top">
      <mx-launch-app :androidDownload="downloadApk"
        ><div class="common-class">
          <span class="text-class">下载美居安卓安装包</span>
        </div></mx-launch-app
      >
    </div>
    <div class="title">ios环境，引导下载美居APP</div>
    <div class="wrapper top">
      <mx-launch-app :iosDownload="iosAppMarket"
        ><div class="common-class">
          <span class="text-class">前往App Store，下载美居APP</span>
        </div></mx-launch-app
      >
    </div>
    <div class="title">跳转至美居指定URL</div>
    <div class="wrapper top">
      <mx-launch-app :targetUrl="target" :mjJumpType="jumpType"
        ><div class="common-class">
          <span class="text-class">前往美居指定页面</span>
        </div></mx-launch-app
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaunchAppDemo',
  components: {},
  data() {
    return {
      showRound: true,
      yingyongbao: '1',
      androidAppMarket: '2',
      downloadApk: '3',
      iosAppMarket: '2',
      linkUrl: 'https://www.pgyer.com/androidmeijupro',
      target:
        'https%3A%2F%2Factivity.msmartlife.cn%2Factivity%2F202201%2Felectricity2%2Findex.html',
      jumpType: 'jumpWebViewNew',
    }
  },
  methods: {
    jumpTo(pageUrl) {
      this.$router.push(pageUrl)
    },
  },
}
</script>
<style lang="scss" scoped>
.contain {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f8fa;
  .title {
    padding-top: 30px;
    margin-left: 20px;
    font-size: 14px;
    color: rgba(69, 90, 100, 0.6);
  }
  .top {
    margin-top: 15px;
  }
  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .common-class {
      width: 338px;
      height: 45px;
      background-color: #ffffff;
      color: #c8c9cc;
      border: none;
      border-radius: 45px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
